import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReceiveAccounts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/receive_account/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceiveAccount(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/receive_account/?id=${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editReceiveAccount(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/receive_account/", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceiveAccount(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/receive_account/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
